import Index from './Index';
import Create from './Create';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

const BroadcastApp = (props) => {
  const { path } = useRouteMatch();
  const theme = props.theme;

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/nova`}>
        <Create theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/editar/:id`}>
        <Create theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
    </Switch>
  );
};

export default BroadcastApp;
